export default __webpack_public_path__ + "static/data-vis-adjacent-color-do-light-f44f07c2f508eefd16d53ab3fc3430a5.png";